//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AdminServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getEnvironment(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetEnvironment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnvironment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnvironment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEnvironment(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSharedSetting(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetSharedSetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSharedSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSharedSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetSharedSetting(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getConnectionString(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetConnectionString";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConnectionString(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConnectionString(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetConnectionString(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    runDbMigrations(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Admin/RunDbMigrations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunDbMigrations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunDbMigrations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRunDbMigrations(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPolicies(): Observable<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetPolicies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolicies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolicies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: string; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: string; }>;
        }));
    }

    protected processGetPolicies(response: HttpResponseBase): Observable<{ [key: string]: string; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getHealthCheck(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetHealthCheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHealthCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHealthCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetHealthCheck(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CityDto> {
        let url_ = this.baseUrl + "/api/services/app/City/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CityDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CityDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/City/GetAll?";
        if (filters !== undefined && filters !== null)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CityDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CityDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CityDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClienteUnicoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filters (optional) 
     * @param inputSearch (optional) 
     * @param clusterId (optional) 
     * @param countryCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, inputSearch: string | null | undefined, clusterId: number | null | undefined, countryCode: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ClienteUnicoItemGridDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ClienteUnico/GetAll?";
        if (filters !== undefined && filters !== null)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (inputSearch !== undefined && inputSearch !== null)
            url_ += "InputSearch=" + encodeURIComponent("" + inputSearch) + "&";
        if (clusterId !== undefined && clusterId !== null)
            url_ += "ClusterId=" + encodeURIComponent("" + clusterId) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClienteUnicoItemGridDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClienteUnicoItemGridDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ClienteUnicoItemGridDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClienteUnicoItemGridDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ClienteUnicoDto | undefined): Observable<ClienteUnicoDto> {
        let url_ = this.baseUrl + "/api/services/app/ClienteUnico/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClienteUnicoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClienteUnicoDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ClienteUnicoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClienteUnicoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param idUnico (optional) 
     * @param document (optional) 
     * @param includePets (optional) 
     * @return Success
     */
    get(idUnico: string | null | undefined, document: string | null | undefined, includePets: boolean | undefined): Observable<ClienteUnicoDto> {
        let url_ = this.baseUrl + "/api/services/app/ClienteUnico/Get?";
        if (idUnico !== undefined && idUnico !== null)
            url_ += "idUnico=" + encodeURIComponent("" + idUnico) + "&";
        if (document !== undefined && document !== null)
            url_ += "document=" + encodeURIComponent("" + document) + "&";
        if (includePets === null)
            throw new Error("The parameter 'includePets' cannot be null.");
        else if (includePets !== undefined)
            url_ += "includePets=" + encodeURIComponent("" + includePets) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClienteUnicoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClienteUnicoDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ClienteUnicoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClienteUnicoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    getByEmail(email: string | null | undefined): Observable<ClienteUnicoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClienteUnico/GetByEmail?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClienteUnicoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClienteUnicoDto[]>;
        }));
    }

    protected processGetByEmail(response: HttpResponseBase): Observable<ClienteUnicoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClienteUnicoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ClienteUnicoDto | undefined): Observable<ClienteUnicoDto> {
        let url_ = this.baseUrl + "/api/services/app/ClienteUnico/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClienteUnicoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClienteUnicoDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ClienteUnicoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClienteUnicoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filters (optional) 
     * @param inputSearch (optional) 
     * @param clusterId (optional) 
     * @param countryCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCsv(filters: string[] | null | undefined, inputSearch: string | null | undefined, clusterId: number | null | undefined, countryCode: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClienteUnico/GetCsv?";
        if (filters !== undefined && filters !== null)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (inputSearch !== undefined && inputSearch !== null)
            url_ += "InputSearch=" + encodeURIComponent("" + inputSearch) + "&";
        if (clusterId !== undefined && clusterId !== null)
            url_ += "ClusterId=" + encodeURIComponent("" + clusterId) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetCsv(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadMassiveCustomers(body: UploadMassiveSingleCustomerDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClienteUnico/UploadMassiveCustomers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadMassiveCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadMassiveCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUploadMassiveCustomers(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateMassiveImport(body: UploadMassiveSingleCustomerDto | undefined): Observable<MassiveImportResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ClienteUnico/ValidateMassiveImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateMassiveImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateMassiveImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MassiveImportResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MassiveImportResultDto>;
        }));
    }

    protected processValidateMassiveImport(response: HttpResponseBase): Observable<MassiveImportResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MassiveImportResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addDirection(body: AddDirectionToClientRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ClienteUnico/AddDirection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDirection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDirection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddDirection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param idUnico (optional) 
     * @param countryCode (optional) 
     * @return Success
     */
    getForApp(idUnico: string | null | undefined, countryCode: string | null | undefined): Observable<ClienteUnicoAppDto> {
        let url_ = this.baseUrl + "/api/services/app/ClienteUnico/GetForApp?";
        if (idUnico !== undefined && idUnico !== null)
            url_ += "idUnico=" + encodeURIComponent("" + idUnico) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForApp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClienteUnicoAppDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClienteUnicoAppDto>;
        }));
    }

    protected processGetForApp(response: HttpResponseBase): Observable<ClienteUnicoAppDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClienteUnicoAppDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param idUnico (optional) 
     * @return Success
     */
    getFidelidadPointsTotal(idUnico: string | null | undefined): Observable<FidelidadPointsTotalDto> {
        let url_ = this.baseUrl + "/api/services/app/ClienteUnico/GetFidelidadPointsTotal?";
        if (idUnico !== undefined && idUnico !== null)
            url_ += "idUnico=" + encodeURIComponent("" + idUnico) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFidelidadPointsTotal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFidelidadPointsTotal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FidelidadPointsTotalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FidelidadPointsTotalDto>;
        }));
    }

    protected processGetFidelidadPointsTotal(response: HttpResponseBase): Observable<FidelidadPointsTotalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FidelidadPointsTotalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param idUnico (optional) 
     * @return Success
     */
    getFidelidadPointsOrder(idUnico: string | null | undefined): Observable<FidelidadOrderPointsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClienteUnico/GetFidelidadPointsOrder?";
        if (idUnico !== undefined && idUnico !== null)
            url_ += "idUnico=" + encodeURIComponent("" + idUnico) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFidelidadPointsOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFidelidadPointsOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FidelidadOrderPointsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FidelidadOrderPointsDto[]>;
        }));
    }

    protected processGetFidelidadPointsOrder(response: HttpResponseBase): Observable<FidelidadOrderPointsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FidelidadOrderPointsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClusterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ClusterDto | undefined): Observable<ClusterDto> {
        let url_ = this.baseUrl + "/api/services/app/Cluster/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClusterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClusterDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ClusterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClusterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ClusterDto | undefined): Observable<ClusterDto> {
        let url_ = this.baseUrl + "/api/services/app/Cluster/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClusterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClusterDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ClusterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClusterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param idUnico (optional) 
     * @return Success
     */
    getByCustomer(idUnico: string | null | undefined): Observable<ClusterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Cluster/GetByCustomer?";
        if (idUnico !== undefined && idUnico !== null)
            url_ += "idUnico=" + encodeURIComponent("" + idUnico) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClusterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClusterDto[]>;
        }));
    }

    protected processGetByCustomer(response: HttpResponseBase): Observable<ClusterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClusterDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Cluster/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ClusterDto> {
        let url_ = this.baseUrl + "/api/services/app/Cluster/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClusterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClusterDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ClusterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClusterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filters (optional) 
     * @param excludeDinamycs (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, excludeDinamycs: boolean | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ClusterDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Cluster/GetAll?";
        if (filters !== undefined && filters !== null)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (excludeDinamycs === null)
            throw new Error("The parameter 'excludeDinamycs' cannot be null.");
        else if (excludeDinamycs !== undefined)
            url_ += "ExcludeDinamycs=" + encodeURIComponent("" + excludeDinamycs) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClusterDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClusterDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ClusterDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClusterDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClusterCustomerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addCustomerToCluster(body: CustomerClusterUpdateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ClusterCustomer/AddCustomerToCluster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomerToCluster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomerToCluster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddCustomerToCluster(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clusterId (optional) 
     * @param customerId (optional) 
     * @param documentNumber (optional) 
     * @return Success
     */
    removeCustomerFromCluster(clusterId: number | undefined, customerId: string | null | undefined, documentNumber: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ClusterCustomer/RemoveCustomerFromCluster?";
        if (clusterId === null)
            throw new Error("The parameter 'clusterId' cannot be null.");
        else if (clusterId !== undefined)
            url_ += "ClusterId=" + encodeURIComponent("" + clusterId) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (documentNumber !== undefined && documentNumber !== null)
            url_ += "DocumentNumber=" + encodeURIComponent("" + documentNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveCustomerFromCluster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveCustomerFromCluster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveCustomerFromCluster(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filters (optional) 
     * @param inputSearch (optional) 
     * @param clusterId (optional) 
     * @param countryCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCsv(filters: string[] | null | undefined, inputSearch: string | null | undefined, clusterId: number | null | undefined, countryCode: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClusterCustomer/GetCsv?";
        if (filters !== undefined && filters !== null)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (inputSearch !== undefined && inputSearch !== null)
            url_ += "InputSearch=" + encodeURIComponent("" + inputSearch) + "&";
        if (clusterId !== undefined && clusterId !== null)
            url_ += "ClusterId=" + encodeURIComponent("" + clusterId) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetCsv(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadCsv(body: ClienteUnicoUploadDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClusterCustomer/UploadCsv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUploadCsv(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExampleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    someAction(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Example/SomeAction";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSomeAction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSomeAction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSomeAction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InvoiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param singleCustomerId (optional) 
     * @param countryCode (optional) 
     * @return Success
     */
    getOld(singleCustomerId: string | null | undefined, countryCode: string | null | undefined): Observable<InvoiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetOld?";
        if (singleCustomerId !== undefined && singleCustomerId !== null)
            url_ += "singleCustomerId=" + encodeURIComponent("" + singleCustomerId) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOld(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOld(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto[]>;
        }));
    }

    protected processGetOld(response: HttpResponseBase): Observable<InvoiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param singleCustomerId (optional) 
     * @param countryCode (optional) 
     * @return Success
     */
    get(singleCustomerId: string | null | undefined, countryCode: string | null | undefined): Observable<InvoiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/Get?";
        if (singleCustomerId !== undefined && singleCustomerId !== null)
            url_ += "singleCustomerId=" + encodeURIComponent("" + singleCustomerId) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InvoiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param number (optional) 
     * @param singleCustomerId (optional) 
     * @param countryCode (optional) 
     * @return Success
     */
    getValidationByNumber(number: string | null | undefined, singleCustomerId: string | null | undefined, countryCode: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetValidationByNumber?";
        if (number !== undefined && number !== null)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        if (singleCustomerId !== undefined && singleCustomerId !== null)
            url_ += "singleCustomerId=" + encodeURIComponent("" + singleCustomerId) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValidationByNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidationByNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetValidationByNumber(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param idUnico (optional) 
     * @param docEntry (optional) 
     * @param countryCode (optional) 
     * @return Success
     */
    getDetail(idUnico: string | null | undefined, docEntry: string | null | undefined, countryCode: string | null | undefined): Observable<DetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetDetail?";
        if (idUnico !== undefined && idUnico !== null)
            url_ += "idUnico=" + encodeURIComponent("" + idUnico) + "&";
        if (docEntry !== undefined && docEntry !== null)
            url_ += "docEntry=" + encodeURIComponent("" + docEntry) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DetailDto[]>;
        }));
    }

    protected processGetDetail(response: HttpResponseBase): Observable<DetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param docEntry (optional) 
     * @param numserie (optional) 
     * @param numalbaran (optional) 
     * @param countryCode (optional) 
     * @return Success
     */
    getDetailOld(docEntry: string | null | undefined, numserie: string | null | undefined, numalbaran: number | undefined, countryCode: string | null | undefined): Observable<DetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetDetailOld?";
        if (docEntry !== undefined && docEntry !== null)
            url_ += "docEntry=" + encodeURIComponent("" + docEntry) + "&";
        if (numserie !== undefined && numserie !== null)
            url_ += "numserie=" + encodeURIComponent("" + numserie) + "&";
        if (numalbaran === null)
            throw new Error("The parameter 'numalbaran' cannot be null.");
        else if (numalbaran !== undefined)
            url_ += "numalbaran=" + encodeURIComponent("" + numalbaran) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailOld(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailOld(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DetailDto[]>;
        }));
    }

    protected processGetDetailOld(response: HttpResponseBase): Observable<DetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param docEntry (optional) 
     * @param countryCode (optional) 
     * @return Success
     */
    getLink(docEntry: string | null | undefined, countryCode: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetLink?";
        if (docEntry !== undefined && docEntry !== null)
            url_ += "docEntry=" + encodeURIComponent("" + docEntry) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetLink(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrdersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param idUnico (optional) 
     * @param documentNumber (optional) 
     * @param countryCode (optional) 
     * @param fromDate (optional) 
     * @return Success
     */
    getOrders(idUnico: string | null | undefined, documentNumber: string | null | undefined, countryCode: string | null | undefined, fromDate: moment.Moment | null | undefined, dias?: number | null | undefined, pageIndex?: number | null | undefined, pageSize?: number | null | undefined): Observable<OrderDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Orders/GetOrders?";
        if (idUnico !== undefined && idUnico !== null)
            url_ += "IdUnico=" + encodeURIComponent("" + idUnico) + "&";
        if (documentNumber !== undefined && documentNumber !== null)
            url_ += "DocumentNumber=" + encodeURIComponent("" + documentNumber) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (dias !== undefined && dias !== null)
            url_ += "Dias=" + encodeURIComponent("" + dias) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDtoListResultDto>;
        }));
    }

    protected processGetOrders(response: HttpResponseBase): Observable<OrderDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProcessServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ProcessDto> {
        let url_ = this.baseUrl + "/api/services/app/Process/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProcessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<StateDto> {
        let url_ = this.baseUrl + "/api/services/app/State/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StateDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StateDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/State/GetAll?";
        if (filters !== undefined && filters !== null)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StateDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StateDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<StateDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StateDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class VetServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getGenders(): Observable<GenderDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Vet/GetGenders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGenders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGenders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenderDto[]>;
        }));
    }

    protected processGetGenders(response: HttpResponseBase): Observable<GenderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GenderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSpecies(): Observable<SpeciesDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Vet/GetSpecies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpecies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpecies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpeciesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpeciesDto[]>;
        }));
    }

    protected processGetSpecies(response: HttpResponseBase): Observable<SpeciesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpeciesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param speciesId (optional) 
     * @return Success
     */
    getBreeds(speciesId: number | null | undefined): Observable<BreedDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Vet/GetBreeds?";
        if (speciesId !== undefined && speciesId !== null)
            url_ += "speciesId=" + encodeURIComponent("" + speciesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBreeds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBreeds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BreedDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BreedDto[]>;
        }));
    }

    protected processGetBreeds(response: HttpResponseBase): Observable<BreedDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BreedDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param documentNumber (optional) 
     * @param includePets (optional) 
     * @return Success
     */
    getCustomer(id: number | null | undefined, documentNumber: string | null | undefined, includePets: boolean | undefined): Observable<CustomerDto> {
        let url_ = this.baseUrl + "/api/services/app/Vet/GetCustomer?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (documentNumber !== undefined && documentNumber !== null)
            url_ += "DocumentNumber=" + encodeURIComponent("" + documentNumber) + "&";
        if (includePets === null)
            throw new Error("The parameter 'includePets' cannot be null.");
        else if (includePets !== undefined)
            url_ += "IncludePets=" + encodeURIComponent("" + includePets) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDto>;
        }));
    }

    protected processGetCustomer(response: HttpResponseBase): Observable<CustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dni (optional) 
     * @return Success
     */
    getCustomerByDni(dni: string | null | undefined): Observable<CustomerDto> {
        let url_ = this.baseUrl + "/api/services/app/Vet/GetCustomerByDni?";
        if (dni !== undefined && dni !== null)
            url_ += "dni=" + encodeURIComponent("" + dni) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerByDni(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerByDni(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDto>;
        }));
    }

    protected processGetCustomerByDni(response: HttpResponseBase): Observable<CustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    getCustomerPets(customerId: number | undefined): Observable<PetDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Vet/GetCustomerPets?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerPets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerPets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PetDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PetDtoListResultDto>;
        }));
    }

    protected processGetCustomerPets(response: HttpResponseBase): Observable<PetDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PetDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPet(body: CreateUpdatePetDto | undefined): Observable<PetDto> {
        let url_ = this.baseUrl + "/api/services/app/Vet/CreatePet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PetDto>;
        }));
    }

    protected processCreatePet(response: HttpResponseBase): Observable<PetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePet(body: CreateUpdatePetDto | undefined): Observable<PetDto> {
        let url_ = this.baseUrl + "/api/services/app/Vet/UpdatePet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PetDto>;
        }));
    }

    protected processUpdatePet(response: HttpResponseBase): Observable<PetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    uploadPicture(file: FileParameter | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Vet/UploadPicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadPicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadPicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadPicture(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class CityDto implements ICityDto {
    name!: string | undefined;
    postalCode!: string | undefined;
    stateId!: number;
    countryCode!: string | undefined;
    id!: number;

    constructor(data?: ICityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.postalCode = _data["postalCode"];
            this.stateId = _data["stateId"];
            this.countryCode = _data["countryCode"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["postalCode"] = this.postalCode;
        data["stateId"] = this.stateId;
        data["countryCode"] = this.countryCode;
        data["id"] = this.id;
        return data;
    }

    clone(): CityDto {
        const json = this.toJSON();
        let result = new CityDto();
        result.init(json);
        return result;
    }
}

export interface ICityDto {
    name: string | undefined;
    postalCode: string | undefined;
    stateId: number;
    countryCode: string | undefined;
    id: number;
}

export class CityDtoPagedResultDto implements ICityDtoPagedResultDto {
    totalCount!: number;
    items!: CityDto[] | undefined;

    constructor(data?: ICityDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CityDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CityDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): CityDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CityDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICityDtoPagedResultDto {
    totalCount: number;
    items: CityDto[] | undefined;
}

export class ClienteUnicoItemGridDto implements IClienteUnicoItemGridDto {
    idUnico!: string | undefined;
    dni!: string | undefined;
    nombres!: string | undefined;
    apellidos!: string | undefined;
    nombresCompletos!: string | undefined;
    telefonos!: string | undefined;
    emails!: string | undefined;
    verificado!: boolean;
    id!: string | undefined;

    constructor(data?: IClienteUnicoItemGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idUnico = _data["idUnico"];
            this.dni = _data["dni"];
            this.nombres = _data["nombres"];
            this.apellidos = _data["apellidos"];
            this.nombresCompletos = _data["nombresCompletos"];
            this.telefonos = _data["telefonos"];
            this.emails = _data["emails"];
            this.verificado = _data["verificado"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClienteUnicoItemGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClienteUnicoItemGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUnico"] = this.idUnico;
        data["dni"] = this.dni;
        data["nombres"] = this.nombres;
        data["apellidos"] = this.apellidos;
        data["nombresCompletos"] = this.nombresCompletos;
        data["telefonos"] = this.telefonos;
        data["emails"] = this.emails;
        data["verificado"] = this.verificado;
        data["id"] = this.id;
        return data;
    }

    clone(): ClienteUnicoItemGridDto {
        const json = this.toJSON();
        let result = new ClienteUnicoItemGridDto();
        result.init(json);
        return result;
    }
}

export interface IClienteUnicoItemGridDto {
    idUnico: string | undefined;
    dni: string | undefined;
    nombres: string | undefined;
    apellidos: string | undefined;
    nombresCompletos: string | undefined;
    telefonos: string | undefined;
    emails: string | undefined;
    verificado: boolean;
    id: string | undefined;
}

export class ClienteUnicoItemGridDtoPagedResultDto implements IClienteUnicoItemGridDtoPagedResultDto {
    totalCount!: number;
    items!: ClienteUnicoItemGridDto[] | undefined;

    constructor(data?: IClienteUnicoItemGridDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClienteUnicoItemGridDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClienteUnicoItemGridDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClienteUnicoItemGridDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ClienteUnicoItemGridDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ClienteUnicoItemGridDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IClienteUnicoItemGridDtoPagedResultDto {
    totalCount: number;
    items: ClienteUnicoItemGridDto[] | undefined;
}

export class SpeciesDto implements ISpeciesDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: ISpeciesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SpeciesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpeciesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): SpeciesDto {
        const json = this.toJSON();
        let result = new SpeciesDto();
        result.init(json);
        return result;
    }
}

export interface ISpeciesDto {
    id: number;
    name: string | undefined;
}

export class BreedDto implements IBreedDto {
    id!: number;
    name!: string | undefined;
    species!: SpeciesDto;

    constructor(data?: IBreedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.species = _data["species"] ? SpeciesDto.fromJS(_data["species"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BreedDto {
        data = typeof data === 'object' ? data : {};
        let result = new BreedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["species"] = this.species ? this.species.toJSON() : <any>undefined;
        return data;
    }

    clone(): BreedDto {
        const json = this.toJSON();
        let result = new BreedDto();
        result.init(json);
        return result;
    }
}

export interface IBreedDto {
    id: number;
    name: string | undefined;
    species: SpeciesDto;
}

export class GenderDto implements IGenderDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IGenderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GenderDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): GenderDto {
        const json = this.toJSON();
        let result = new GenderDto();
        result.init(json);
        return result;
    }
}

export interface IGenderDto {
    id: number;
    name: string | undefined;
}

export class PetDto implements IPetDto {
    id!: number;
    name!: string | undefined;
    pictureUrl!: string | undefined;
    birthdate!: moment.Moment;
    species!: SpeciesDto;
    breed!: BreedDto;
    microChip!: string | undefined;
    color!: string | undefined;
    gender!: GenderDto;
    deceased!: boolean;
    sourceType!: number;
    conditions!: string[] | undefined;
    owners!: CustomerDto[] | undefined;

    constructor(data?: IPetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.pictureUrl = _data["pictureUrl"];
            this.birthdate = _data["birthdate"] ? moment(_data["birthdate"].toString()) : <any>undefined;
            this.species = _data["species"] ? SpeciesDto.fromJS(_data["species"]) : <any>undefined;
            this.breed = _data["breed"] ? BreedDto.fromJS(_data["breed"]) : <any>undefined;
            this.microChip = _data["microChip"];
            this.color = _data["color"];
            this.gender = _data["gender"] ? GenderDto.fromJS(_data["gender"]) : <any>undefined;
            this.deceased = _data["deceased"];
            this.sourceType = _data["sourceType"];
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(item);
            }
            if (Array.isArray(_data["owners"])) {
                this.owners = [] as any;
                for (let item of _data["owners"])
                    this.owners!.push(CustomerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PetDto {
        data = typeof data === 'object' ? data : {};
        let result = new PetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["pictureUrl"] = this.pictureUrl;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : <any>undefined;
        data["species"] = this.species ? this.species.toJSON() : <any>undefined;
        data["breed"] = this.breed ? this.breed.toJSON() : <any>undefined;
        data["microChip"] = this.microChip;
        data["color"] = this.color;
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["deceased"] = this.deceased;
        data["sourceType"] = this.sourceType;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item);
        }
        if (Array.isArray(this.owners)) {
            data["owners"] = [];
            for (let item of this.owners)
                data["owners"].push(item.toJSON());
        }
        return data;
    }

    clone(): PetDto {
        const json = this.toJSON();
        let result = new PetDto();
        result.init(json);
        return result;
    }
}

export interface IPetDto {
    id: number;
    name: string | undefined;
    pictureUrl: string | undefined;
    birthdate: moment.Moment;
    species: SpeciesDto;
    breed: BreedDto;
    microChip: string | undefined;
    color: string | undefined;
    gender: GenderDto;
    deceased: boolean;
    sourceType: number;
    conditions: string[] | undefined;
    owners: CustomerDto[] | undefined;
}

export class CustomerDto implements ICustomerDto {
    id!: number;
    firstName!: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    phoneNumber!: string | undefined;
    documentNumber!: string | undefined;
    pets!: PetDto[] | undefined;

    constructor(data?: ICustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.documentNumber = _data["documentNumber"];
            if (Array.isArray(_data["pets"])) {
                this.pets = [] as any;
                for (let item of _data["pets"])
                    this.pets!.push(PetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["documentNumber"] = this.documentNumber;
        if (Array.isArray(this.pets)) {
            data["pets"] = [];
            for (let item of this.pets)
                data["pets"].push(item.toJSON());
        }
        return data;
    }

    clone(): CustomerDto {
        const json = this.toJSON();
        let result = new CustomerDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerDto {
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    documentNumber: string | undefined;
    pets: PetDto[] | undefined;
}

export class MascotaClienteDto implements IMascotaClienteDto {
    id!: number;
    nombre!: string | undefined;
    idEspecie!: number;
    especie!: string | undefined;
    idRaza!: number;
    raza!: string | undefined;
    idGenero!: number;
    genero!: string | undefined;
    fechaNacimiento!: moment.Moment;
    microChip!: string | undefined;
    colores!: string | undefined;
    imagen!: string | undefined;
    conditions!: string[] | undefined;
    owners!: CustomerDto[] | undefined;

    constructor(data?: IMascotaClienteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nombre = _data["nombre"];
            this.idEspecie = _data["idEspecie"];
            this.especie = _data["especie"];
            this.idRaza = _data["idRaza"];
            this.raza = _data["raza"];
            this.idGenero = _data["idGenero"];
            this.genero = _data["genero"];
            this.fechaNacimiento = _data["fechaNacimiento"] ? moment(_data["fechaNacimiento"].toString()) : <any>undefined;
            this.microChip = _data["microChip"];
            this.colores = _data["colores"];
            this.imagen = _data["imagen"];
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(item);
            }
            if (Array.isArray(_data["owners"])) {
                this.owners = [] as any;
                for (let item of _data["owners"])
                    this.owners!.push(CustomerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MascotaClienteDto {
        data = typeof data === 'object' ? data : {};
        let result = new MascotaClienteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nombre"] = this.nombre;
        data["idEspecie"] = this.idEspecie;
        data["especie"] = this.especie;
        data["idRaza"] = this.idRaza;
        data["raza"] = this.raza;
        data["idGenero"] = this.idGenero;
        data["genero"] = this.genero;
        data["fechaNacimiento"] = this.fechaNacimiento ? this.fechaNacimiento.toISOString() : <any>undefined;
        data["microChip"] = this.microChip;
        data["colores"] = this.colores;
        data["imagen"] = this.imagen;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item);
        }
        if (Array.isArray(this.owners)) {
            data["owners"] = [];
            for (let item of this.owners)
                data["owners"].push(item.toJSON());
        }
        return data;
    }

    clone(): MascotaClienteDto {
        const json = this.toJSON();
        let result = new MascotaClienteDto();
        result.init(json);
        return result;
    }
}

export interface IMascotaClienteDto {
    id: number;
    nombre: string | undefined;
    idEspecie: number;
    especie: string | undefined;
    idRaza: number;
    raza: string | undefined;
    idGenero: number;
    genero: string | undefined;
    fechaNacimiento: moment.Moment;
    microChip: string | undefined;
    colores: string | undefined;
    imagen: string | undefined;
    conditions: string[] | undefined;
    owners: CustomerDto[] | undefined;
}

export class NombreClienteDto implements INombreClienteDto {
    nombre!: string | undefined;
    origen!: string | undefined;
    status!: number;

    constructor(data?: INombreClienteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nombre = _data["nombre"];
            this.origen = _data["origen"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): NombreClienteDto {
        data = typeof data === 'object' ? data : {};
        let result = new NombreClienteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nombre"] = this.nombre;
        data["origen"] = this.origen;
        data["status"] = this.status;
        return data;
    }

    clone(): NombreClienteDto {
        const json = this.toJSON();
        let result = new NombreClienteDto();
        result.init(json);
        return result;
    }
}

export interface INombreClienteDto {
    nombre: string | undefined;
    origen: string | undefined;
    status: number;
}

export class NombreCompletoClienteDto implements INombreCompletoClienteDto {
    nombreCompleto!: string | undefined;
    origen!: string | undefined;
    status!: number;

    constructor(data?: INombreCompletoClienteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nombreCompleto = _data["nombreCompleto"];
            this.origen = _data["origen"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): NombreCompletoClienteDto {
        data = typeof data === 'object' ? data : {};
        let result = new NombreCompletoClienteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nombreCompleto"] = this.nombreCompleto;
        data["origen"] = this.origen;
        data["status"] = this.status;
        return data;
    }

    clone(): NombreCompletoClienteDto {
        const json = this.toJSON();
        let result = new NombreCompletoClienteDto();
        result.init(json);
        return result;
    }
}

export interface INombreCompletoClienteDto {
    nombreCompleto: string | undefined;
    origen: string | undefined;
    status: number;
}

export class ApellidoClienteDto implements IApellidoClienteDto {
    apellido!: string | undefined;
    origen!: string | undefined;
    status!: number;

    constructor(data?: IApellidoClienteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apellido = _data["apellido"];
            this.origen = _data["origen"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ApellidoClienteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApellidoClienteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apellido"] = this.apellido;
        data["origen"] = this.origen;
        data["status"] = this.status;
        return data;
    }

    clone(): ApellidoClienteDto {
        const json = this.toJSON();
        let result = new ApellidoClienteDto();
        result.init(json);
        return result;
    }
}

export interface IApellidoClienteDto {
    apellido: string | undefined;
    origen: string | undefined;
    status: number;
}

export class TelefonoClienteDto implements ITelefonoClienteDto {
    codigoDeArea!: string | undefined;
    telefono!: string | undefined;
    tipo!: string | undefined;
    origen!: string | undefined;
    status!: number;

    constructor(data?: ITelefonoClienteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigoDeArea = _data["codigoDeArea"];
            this.telefono = _data["telefono"];
            this.tipo = _data["tipo"];
            this.origen = _data["origen"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TelefonoClienteDto {
        data = typeof data === 'object' ? data : {};
        let result = new TelefonoClienteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigoDeArea"] = this.codigoDeArea;
        data["telefono"] = this.telefono;
        data["tipo"] = this.tipo;
        data["origen"] = this.origen;
        data["status"] = this.status;
        return data;
    }

    clone(): TelefonoClienteDto {
        const json = this.toJSON();
        let result = new TelefonoClienteDto();
        result.init(json);
        return result;
    }
}

export interface ITelefonoClienteDto {
    codigoDeArea: string | undefined;
    telefono: string | undefined;
    tipo: string | undefined;
    origen: string | undefined;
    status: number;
}

export class DomicilioClienteDto implements IDomicilioClienteDto {
    calle!: string | undefined;
    numero!: string | undefined;
    piso!: string | undefined;
    departamento!: string | undefined;
    tipo!: string | undefined;
    codigoPostal!: string | undefined;
    localidad!: string | undefined;
    provincia!: string | undefined;
    pais!: string | undefined;
    origen!: string | undefined;
    status!: number;

    constructor(data?: IDomicilioClienteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calle = _data["calle"];
            this.numero = _data["numero"];
            this.piso = _data["piso"];
            this.departamento = _data["departamento"];
            this.tipo = _data["tipo"];
            this.codigoPostal = _data["codigoPostal"];
            this.localidad = _data["localidad"];
            this.provincia = _data["provincia"];
            this.pais = _data["pais"];
            this.origen = _data["origen"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): DomicilioClienteDto {
        data = typeof data === 'object' ? data : {};
        let result = new DomicilioClienteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calle"] = this.calle;
        data["numero"] = this.numero;
        data["piso"] = this.piso;
        data["departamento"] = this.departamento;
        data["tipo"] = this.tipo;
        data["codigoPostal"] = this.codigoPostal;
        data["localidad"] = this.localidad;
        data["provincia"] = this.provincia;
        data["pais"] = this.pais;
        data["origen"] = this.origen;
        data["status"] = this.status;
        return data;
    }

    clone(): DomicilioClienteDto {
        const json = this.toJSON();
        let result = new DomicilioClienteDto();
        result.init(json);
        return result;
    }
}

export interface IDomicilioClienteDto {
    calle: string | undefined;
    numero: string | undefined;
    piso: string | undefined;
    departamento: string | undefined;
    tipo: string | undefined;
    codigoPostal: string | undefined;
    localidad: string | undefined;
    provincia: string | undefined;
    pais: string | undefined;
    origen: string | undefined;
    status: number;
}

export class EmailClienteDto implements IEmailClienteDto {
    email!: string | undefined;
    tipo!: string | undefined;
    origen!: string | undefined;
    status!: number;

    constructor(data?: IEmailClienteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.tipo = _data["tipo"];
            this.origen = _data["origen"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): EmailClienteDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailClienteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["tipo"] = this.tipo;
        data["origen"] = this.origen;
        data["status"] = this.status;
        return data;
    }

    clone(): EmailClienteDto {
        const json = this.toJSON();
        let result = new EmailClienteDto();
        result.init(json);
        return result;
    }
}

export interface IEmailClienteDto {
    email: string | undefined;
    tipo: string | undefined;
    origen: string | undefined;
    status: number;
}

export class ClusterClienteDto implements IClusterClienteDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IClusterClienteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ClusterClienteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClusterClienteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): ClusterClienteDto {
        const json = this.toJSON();
        let result = new ClusterClienteDto();
        result.init(json);
        return result;
    }
}

export interface IClusterClienteDto {
    id: number;
    name: string | undefined;
}

export class ClusterLogClienteDto implements IClusterLogClienteDto {
    clusterId!: number;
    fecha!: string | undefined;
    accion!: string | undefined;
    log!: string | undefined;

    constructor(data?: IClusterLogClienteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clusterId = _data["clusterId"];
            this.fecha = _data["fecha"];
            this.accion = _data["accion"];
            this.log = _data["log"];
        }
    }

    static fromJS(data: any): ClusterLogClienteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClusterLogClienteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterId"] = this.clusterId;
        data["fecha"] = this.fecha;
        data["accion"] = this.accion;
        data["log"] = this.log;
        return data;
    }

    clone(): ClusterLogClienteDto {
        const json = this.toJSON();
        let result = new ClusterLogClienteDto();
        result.init(json);
        return result;
    }
}

export interface IClusterLogClienteDto {
    clusterId: number;
    fecha: string | undefined;
    accion: string | undefined;
    log: string | undefined;
}

export class FidelizacionClienteDto implements IFidelizacionClienteDto {
    r!: number;
    f!: number;
    m!: number;
    tier!: string | undefined;
    segmento!: string | undefined;
    periodo!: string | undefined;

    constructor(data?: IFidelizacionClienteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.r = _data["r"];
            this.f = _data["f"];
            this.m = _data["m"];
            this.tier = _data["tier"];
            this.segmento = _data["segmento"];
            this.periodo = _data["periodo"];
        }
    }

    static fromJS(data: any): FidelizacionClienteDto {
        data = typeof data === 'object' ? data : {};
        let result = new FidelizacionClienteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["r"] = this.r;
        data["f"] = this.f;
        data["m"] = this.m;
        data["tier"] = this.tier;
        data["segmento"] = this.segmento;
        data["periodo"] = this.periodo;
        return data;
    }

    clone(): FidelizacionClienteDto {
        const json = this.toJSON();
        let result = new FidelizacionClienteDto();
        result.init(json);
        return result;
    }
}

export interface IFidelizacionClienteDto {
    r: number;
    f: number;
    m: number;
    tier: string | undefined;
    segmento: string | undefined;
    periodo: string | undefined;
}

export class ClienteUnicoDto implements IClienteUnicoDto {
    idUnico!: string | undefined;
    dni!: string | undefined;
    mascotas!: MascotaClienteDto[] | undefined;
    nombres!: NombreClienteDto[] | undefined;
    nombresCompletos!: NombreCompletoClienteDto[] | undefined;
    apellidos!: ApellidoClienteDto[] | undefined;
    telefonos!: TelefonoClienteDto[] | undefined;
    domicilios!: DomicilioClienteDto[] | undefined;
    emails!: EmailClienteDto[] | undefined;
    clusters!: ClusterClienteDto[] | undefined;
    clustersLog!: ClusterLogClienteDto[] | undefined;
    fidelizacion!: FidelizacionClienteDto[] | undefined;
    verificado!: boolean;
    nombrePrincipal!: string | undefined;
    apellidoPrincipal!: string | undefined;
    nombreCompletoPrincipal!: string | undefined;
    telefonoPrincipal!: string | undefined;
    emailPrincipal!: string | undefined;
    domicilioPrincipal!: number | undefined;
    /** Tienda habitual del cliente. Lo agrego la consultora al backend (commit 652a2cd);
     * el proxy generado todavia no lo tenia. Guarda el storeCode. */
    codigoTienda!: string | undefined;
    ultimaActualizacion!: string | undefined;
    id!: string | undefined;

    constructor(data?: IClienteUnicoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idUnico = _data["idUnico"];
            this.dni = _data["dni"];
            if (Array.isArray(_data["mascotas"])) {
                this.mascotas = [] as any;
                for (let item of _data["mascotas"])
                    this.mascotas!.push(MascotaClienteDto.fromJS(item));
            }
            if (Array.isArray(_data["nombres"])) {
                this.nombres = [] as any;
                for (let item of _data["nombres"])
                    this.nombres!.push(NombreClienteDto.fromJS(item));
            }
            if (Array.isArray(_data["nombresCompletos"])) {
                this.nombresCompletos = [] as any;
                for (let item of _data["nombresCompletos"])
                    this.nombresCompletos!.push(NombreCompletoClienteDto.fromJS(item));
            }
            if (Array.isArray(_data["apellidos"])) {
                this.apellidos = [] as any;
                for (let item of _data["apellidos"])
                    this.apellidos!.push(ApellidoClienteDto.fromJS(item));
            }
            if (Array.isArray(_data["telefonos"])) {
                this.telefonos = [] as any;
                for (let item of _data["telefonos"])
                    this.telefonos!.push(TelefonoClienteDto.fromJS(item));
            }
            if (Array.isArray(_data["domicilios"])) {
                this.domicilios = [] as any;
                for (let item of _data["domicilios"])
                    this.domicilios!.push(DomicilioClienteDto.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(EmailClienteDto.fromJS(item));
            }
            if (Array.isArray(_data["clusters"])) {
                this.clusters = [] as any;
                for (let item of _data["clusters"])
                    this.clusters!.push(ClusterClienteDto.fromJS(item));
            }
            if (Array.isArray(_data["clustersLog"])) {
                this.clustersLog = [] as any;
                for (let item of _data["clustersLog"])
                    this.clustersLog!.push(ClusterLogClienteDto.fromJS(item));
            }
            if (Array.isArray(_data["fidelizacion"])) {
                this.fidelizacion = [] as any;
                for (let item of _data["fidelizacion"])
                    this.fidelizacion!.push(FidelizacionClienteDto.fromJS(item));
            }
            this.verificado = _data["verificado"];
            this.nombrePrincipal = _data["nombrePrincipal"];
            this.apellidoPrincipal = _data["apellidoPrincipal"];
            this.nombreCompletoPrincipal = _data["nombreCompletoPrincipal"];
            this.telefonoPrincipal = _data["telefonoPrincipal"];
            this.emailPrincipal = _data["emailPrincipal"];
            this.domicilioPrincipal = _data["domicilioPrincipal"];
            this.codigoTienda = _data["codigoTienda"];
            this.ultimaActualizacion = _data["ultimaActualizacion"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClienteUnicoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClienteUnicoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUnico"] = this.idUnico;
        data["dni"] = this.dni;
        if (Array.isArray(this.mascotas)) {
            data["mascotas"] = [];
            for (let item of this.mascotas)
                data["mascotas"].push(item.toJSON());
        }
        if (Array.isArray(this.nombres)) {
            data["nombres"] = [];
            for (let item of this.nombres)
                data["nombres"].push(item.toJSON());
        }
        if (Array.isArray(this.nombresCompletos)) {
            data["nombresCompletos"] = [];
            for (let item of this.nombresCompletos)
                data["nombresCompletos"].push(item.toJSON());
        }
        if (Array.isArray(this.apellidos)) {
            data["apellidos"] = [];
            for (let item of this.apellidos)
                data["apellidos"].push(item.toJSON());
        }
        if (Array.isArray(this.telefonos)) {
            data["telefonos"] = [];
            for (let item of this.telefonos)
                data["telefonos"].push(item.toJSON());
        }
        if (Array.isArray(this.domicilios)) {
            data["domicilios"] = [];
            for (let item of this.domicilios)
                data["domicilios"].push(item.toJSON());
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        if (Array.isArray(this.clusters)) {
            data["clusters"] = [];
            for (let item of this.clusters)
                data["clusters"].push(item.toJSON());
        }
        if (Array.isArray(this.clustersLog)) {
            data["clustersLog"] = [];
            for (let item of this.clustersLog)
                data["clustersLog"].push(item.toJSON());
        }
        if (Array.isArray(this.fidelizacion)) {
            data["fidelizacion"] = [];
            for (let item of this.fidelizacion)
                data["fidelizacion"].push(item.toJSON());
        }
        data["verificado"] = this.verificado;
        data["nombrePrincipal"] = this.nombrePrincipal;
        data["apellidoPrincipal"] = this.apellidoPrincipal;
        data["nombreCompletoPrincipal"] = this.nombreCompletoPrincipal;
        data["telefonoPrincipal"] = this.telefonoPrincipal;
        data["emailPrincipal"] = this.emailPrincipal;
        data["domicilioPrincipal"] = this.domicilioPrincipal;
        data["codigoTienda"] = this.codigoTienda;
        data["ultimaActualizacion"] = this.ultimaActualizacion;
        data["id"] = this.id;
        return data;
    }

    clone(): ClienteUnicoDto {
        const json = this.toJSON();
        let result = new ClienteUnicoDto();
        result.init(json);
        return result;
    }
}

export interface IClienteUnicoDto {
    idUnico: string | undefined;
    dni: string | undefined;
    mascotas: MascotaClienteDto[] | undefined;
    nombres: NombreClienteDto[] | undefined;
    nombresCompletos: NombreCompletoClienteDto[] | undefined;
    apellidos: ApellidoClienteDto[] | undefined;
    telefonos: TelefonoClienteDto[] | undefined;
    domicilios: DomicilioClienteDto[] | undefined;
    emails: EmailClienteDto[] | undefined;
    clusters: ClusterClienteDto[] | undefined;
    clustersLog: ClusterLogClienteDto[] | undefined;
    fidelizacion: FidelizacionClienteDto[] | undefined;
    verificado: boolean;
    nombrePrincipal: string | undefined;
    apellidoPrincipal: string | undefined;
    nombreCompletoPrincipal: string | undefined;
    telefonoPrincipal: string | undefined;
    emailPrincipal: string | undefined;
    domicilioPrincipal: number | undefined;
    codigoTienda: string | undefined;
    ultimaActualizacion: string | undefined;
    id: string | undefined;
}

export class UploadMassiveSingleCustomerDto implements IUploadMassiveSingleCustomerDto {
    url!: string | undefined;
    countryCode!: string | undefined;
    isValidation!: boolean;

    constructor(data?: IUploadMassiveSingleCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.countryCode = _data["countryCode"];
            this.isValidation = _data["isValidation"];
        }
    }

    static fromJS(data: any): UploadMassiveSingleCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadMassiveSingleCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["countryCode"] = this.countryCode;
        data["isValidation"] = this.isValidation;
        return data;
    }

    clone(): UploadMassiveSingleCustomerDto {
        const json = this.toJSON();
        let result = new UploadMassiveSingleCustomerDto();
        result.init(json);
        return result;
    }
}

export interface IUploadMassiveSingleCustomerDto {
    url: string | undefined;
    countryCode: string | undefined;
    isValidation: boolean;
}

export class MassiveImportResultItemDto implements IMassiveImportResultItemDto {
    idRegistro!: number;
    dniNoCargado!: boolean;
    emailNoCargado!: boolean;
    direccionIncompleta!: boolean;

    constructor(data?: IMassiveImportResultItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idRegistro = _data["idRegistro"];
            this.dniNoCargado = _data["dniNoCargado"];
            this.emailNoCargado = _data["emailNoCargado"];
            this.direccionIncompleta = _data["direccionIncompleta"];
        }
    }

    static fromJS(data: any): MassiveImportResultItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MassiveImportResultItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idRegistro"] = this.idRegistro;
        data["dniNoCargado"] = this.dniNoCargado;
        data["emailNoCargado"] = this.emailNoCargado;
        data["direccionIncompleta"] = this.direccionIncompleta;
        return data;
    }

    clone(): MassiveImportResultItemDto {
        const json = this.toJSON();
        let result = new MassiveImportResultItemDto();
        result.init(json);
        return result;
    }
}

export interface IMassiveImportResultItemDto {
    idRegistro: number;
    dniNoCargado: boolean;
    emailNoCargado: boolean;
    direccionIncompleta: boolean;
}

export class MassiveImportResultDto implements IMassiveImportResultDto {
    message!: string | undefined;
    items!: MassiveImportResultItemDto[] | undefined;
    cantidadNuevos!: number;
    cantidadModificados!: number;
    cantidadConError!: number;
    esValidacion!: boolean;

    constructor(data?: IMassiveImportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MassiveImportResultItemDto.fromJS(item));
            }
            this.cantidadNuevos = _data["cantidadNuevos"];
            this.cantidadModificados = _data["cantidadModificados"];
            this.cantidadConError = _data["cantidadConError"];
            this.esValidacion = _data["esValidacion"];
        }
    }

    static fromJS(data: any): MassiveImportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MassiveImportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["cantidadNuevos"] = this.cantidadNuevos;
        data["cantidadModificados"] = this.cantidadModificados;
        data["cantidadConError"] = this.cantidadConError;
        data["esValidacion"] = this.esValidacion;
        return data;
    }

    clone(): MassiveImportResultDto {
        const json = this.toJSON();
        let result = new MassiveImportResultDto();
        result.init(json);
        return result;
    }
}

export interface IMassiveImportResultDto {
    message: string | undefined;
    items: MassiveImportResultItemDto[] | undefined;
    cantidadNuevos: number;
    cantidadModificados: number;
    cantidadConError: number;
    esValidacion: boolean;
}

export class AddDirectionToClientRequest implements IAddDirectionToClientRequest {
    documentNumber!: string | undefined;
    country!: string | undefined;
    state!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    postalCode!: string | undefined;
    number!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: IAddDirectionToClientRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentNumber = _data["documentNumber"];
            this.country = _data["country"];
            this.state = _data["state"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.postalCode = _data["postalCode"];
            this.number = _data["number"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): AddDirectionToClientRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddDirectionToClientRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNumber"] = this.documentNumber;
        data["country"] = this.country;
        data["state"] = this.state;
        data["city"] = this.city;
        data["street"] = this.street;
        data["postalCode"] = this.postalCode;
        data["number"] = this.number;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }

    clone(): AddDirectionToClientRequest {
        const json = this.toJSON();
        let result = new AddDirectionToClientRequest();
        result.init(json);
        return result;
    }
}

export interface IAddDirectionToClientRequest {
    documentNumber: string | undefined;
    country: string | undefined;
    state: string | undefined;
    city: string | undefined;
    street: string | undefined;
    postalCode: string | undefined;
    number: string | undefined;
    phoneNumber: string | undefined;
}

export class ClienteUnicoClusterAppDto implements IClienteUnicoClusterAppDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IClienteUnicoClusterAppDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ClienteUnicoClusterAppDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClienteUnicoClusterAppDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): ClienteUnicoClusterAppDto {
        const json = this.toJSON();
        let result = new ClienteUnicoClusterAppDto();
        result.init(json);
        return result;
    }
}

export interface IClienteUnicoClusterAppDto {
    id: number;
    name: string | undefined;
}

export class FidelidadPointsTotalDto implements IFidelidadPointsTotalDto {
    id_unico!: string | undefined;
    idPais!: string | undefined;
    nombreTier!: string | undefined;
    puntosTotales!: string | undefined;
    puntosAVencer!: string | undefined;
    puntosMesActual!: string | undefined;
    puntosNextTier!: string | undefined;

    constructor(data?: IFidelidadPointsTotalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id_unico = _data["id_unico"];
            this.idPais = _data["idPais"];
            this.nombreTier = _data["nombreTier"];
            this.puntosTotales = _data["puntosTotales"];
            this.puntosAVencer = _data["puntosAVencer"];
            this.puntosMesActual = _data["puntosMesActual"];
            this.puntosNextTier = _data["puntosNextTier"];
        }
    }

    static fromJS(data: any): FidelidadPointsTotalDto {
        data = typeof data === 'object' ? data : {};
        let result = new FidelidadPointsTotalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id_unico"] = this.id_unico;
        data["idPais"] = this.idPais;
        data["nombreTier"] = this.nombreTier;
        data["puntosTotales"] = this.puntosTotales;
        data["puntosAVencer"] = this.puntosAVencer;
        data["puntosMesActual"] = this.puntosMesActual;
        data["puntosNextTier"] = this.puntosNextTier;
        return data;
    }

    clone(): FidelidadPointsTotalDto {
        const json = this.toJSON();
        let result = new FidelidadPointsTotalDto();
        result.init(json);
        return result;
    }
}

export interface IFidelidadPointsTotalDto {
    id_unico: string | undefined;
    idPais: string | undefined;
    nombreTier: string | undefined;
    puntosTotales: string | undefined;
    puntosAVencer: string | undefined;
    puntosMesActual: string | undefined;
    puntosNextTier: string | undefined;
}

export class ClienteUnicoAppDto implements IClienteUnicoAppDto {
    idUnico!: string | undefined;
    dni!: string | undefined;
    emailPrincipal!: string | undefined;
    verificado!: boolean;
    nombrePrincipal!: string | undefined;
    apellidoPrincipal!: string | undefined;
    nombreCompletoPrincipal!: string | undefined;
    pets!: PetDto[] | undefined;
    clienteClusters!: ClienteUnicoClusterAppDto[] | undefined;
    fidelidadPointsTotal!: FidelidadPointsTotalDto;

    constructor(data?: IClienteUnicoAppDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idUnico = _data["idUnico"];
            this.dni = _data["dni"];
            this.emailPrincipal = _data["emailPrincipal"];
            this.verificado = _data["verificado"];
            this.nombrePrincipal = _data["nombrePrincipal"];
            this.apellidoPrincipal = _data["apellidoPrincipal"];
            this.nombreCompletoPrincipal = _data["nombreCompletoPrincipal"];
            if (Array.isArray(_data["pets"])) {
                this.pets = [] as any;
                for (let item of _data["pets"])
                    this.pets!.push(PetDto.fromJS(item));
            }
            if (Array.isArray(_data["clienteClusters"])) {
                this.clienteClusters = [] as any;
                for (let item of _data["clienteClusters"])
                    this.clienteClusters!.push(ClienteUnicoClusterAppDto.fromJS(item));
            }
            this.fidelidadPointsTotal = _data["fidelidadPointsTotal"] ? FidelidadPointsTotalDto.fromJS(_data["fidelidadPointsTotal"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ClienteUnicoAppDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClienteUnicoAppDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUnico"] = this.idUnico;
        data["dni"] = this.dni;
        data["emailPrincipal"] = this.emailPrincipal;
        data["verificado"] = this.verificado;
        data["nombrePrincipal"] = this.nombrePrincipal;
        data["apellidoPrincipal"] = this.apellidoPrincipal;
        data["nombreCompletoPrincipal"] = this.nombreCompletoPrincipal;
        if (Array.isArray(this.pets)) {
            data["pets"] = [];
            for (let item of this.pets)
                data["pets"].push(item.toJSON());
        }
        if (Array.isArray(this.clienteClusters)) {
            data["clienteClusters"] = [];
            for (let item of this.clienteClusters)
                data["clienteClusters"].push(item.toJSON());
        }
        data["fidelidadPointsTotal"] = this.fidelidadPointsTotal ? this.fidelidadPointsTotal.toJSON() : <any>undefined;
        return data;
    }

    clone(): ClienteUnicoAppDto {
        const json = this.toJSON();
        let result = new ClienteUnicoAppDto();
        result.init(json);
        return result;
    }
}

export interface IClienteUnicoAppDto {
    idUnico: string | undefined;
    dni: string | undefined;
    emailPrincipal: string | undefined;
    verificado: boolean;
    nombrePrincipal: string | undefined;
    apellidoPrincipal: string | undefined;
    nombreCompletoPrincipal: string | undefined;
    pets: PetDto[] | undefined;
    clienteClusters: ClienteUnicoClusterAppDto[] | undefined;
    fidelidadPointsTotal: FidelidadPointsTotalDto;
}

export class FidelidadOrderPointsDto implements IFidelidadOrderPointsDto {
    fecha!: string | undefined;
    nroComprobante!: string | undefined;
    puntosCompra!: string | undefined;
    puntosPesos!: string | undefined;
    puntos!: string | undefined;
    tipo!: string | undefined;
    lugar!: string | undefined;

    constructor(data?: IFidelidadOrderPointsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fecha = _data["fecha"];
            this.nroComprobante = _data["nroComprobante"];
            this.puntosCompra = _data["puntosCompra"];
            this.puntosPesos = _data["puntosPesos"];
            this.tipo = _data["tipo"];
            this.puntos = _data["puntos"];
            this.lugar = _data["lugar"];
        }
    }

    static fromJS(data: any): FidelidadOrderPointsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FidelidadOrderPointsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fecha"] = this.fecha;
        data["nroComprobante"] = this.nroComprobante;
        data["puntosCompra"] = this.puntosCompra;
        data["puntosPesos"] = this.puntosPesos;
        data["tipo"] = this.tipo;
        data["puntos"] = this.puntos;
        data["lugar"] = this.lugar;
        return data;
    }

    clone(): FidelidadOrderPointsDto {
        const json = this.toJSON();
        let result = new FidelidadOrderPointsDto();
        result.init(json);
        return result;
    }
}

export interface IFidelidadOrderPointsDto {
    fecha: string | undefined;
    nroComprobante: string | undefined;
    puntosCompra: string | undefined;
    puntosPesos: string | undefined;
    tipo: string | undefined;
    puntos: string | undefined;
    lugar: string | undefined;
}

export class ClusterSourceDto implements IClusterSourceDto {
    clusterId!: number;
    sourceId!: string | undefined;
    sourceName!: string | undefined;
    id!: number;

    constructor(data?: IClusterSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clusterId = _data["clusterId"];
            this.sourceId = _data["sourceId"];
            this.sourceName = _data["sourceName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClusterSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClusterSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterId"] = this.clusterId;
        data["sourceId"] = this.sourceId;
        data["sourceName"] = this.sourceName;
        data["id"] = this.id;
        return data;
    }

    clone(): ClusterSourceDto {
        const json = this.toJSON();
        let result = new ClusterSourceDto();
        result.init(json);
        return result;
    }
}

export interface IClusterSourceDto {
    clusterId: number;
    sourceId: string | undefined;
    sourceName: string | undefined;
    id: number;
}

export class ClusterDto implements IClusterDto {
    code!: string | undefined;
    name!: string | undefined;
    type!: string | undefined;
    customersQuantity!: number;
    sources!: ClusterSourceDto[] | undefined;
    priority!: number;
    customersCount!: number;
    id!: number;

    constructor(data?: IClusterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.customersQuantity = _data["customersQuantity"];
            if (Array.isArray(_data["sources"])) {
                this.sources = [] as any;
                for (let item of _data["sources"])
                    this.sources!.push(ClusterSourceDto.fromJS(item));
            }
            this.priority = _data["priority"];
            this.customersCount = _data["customersCount"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClusterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClusterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["type"] = this.type;
        data["customersQuantity"] = this.customersQuantity;
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item of this.sources)
                data["sources"].push(item.toJSON());
        }
        data["priority"] = this.priority;
        data["customersCount"] = this.customersCount;
        data["id"] = this.id;
        return data;
    }

    clone(): ClusterDto {
        const json = this.toJSON();
        let result = new ClusterDto();
        result.init(json);
        return result;
    }
}

export interface IClusterDto {
    code: string | undefined;
    name: string | undefined;
    type: string | undefined;
    customersQuantity: number;
    sources: ClusterSourceDto[] | undefined;
    priority: number;
    customersCount: number;
    id: number;
}

export class ClusterDtoPagedResultDto implements IClusterDtoPagedResultDto {
    totalCount!: number;
    items!: ClusterDto[] | undefined;

    constructor(data?: IClusterDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClusterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClusterDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClusterDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ClusterDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ClusterDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IClusterDtoPagedResultDto {
    totalCount: number;
    items: ClusterDto[] | undefined;
}

export class CustomerClusterUpdateDto implements ICustomerClusterUpdateDto {
    clusterId!: number;
    customerId!: string | undefined;
    documentNumber!: string | undefined;

    constructor(data?: ICustomerClusterUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clusterId = _data["clusterId"];
            this.customerId = _data["customerId"];
            this.documentNumber = _data["documentNumber"];
        }
    }

    static fromJS(data: any): CustomerClusterUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerClusterUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterId"] = this.clusterId;
        data["customerId"] = this.customerId;
        data["documentNumber"] = this.documentNumber;
        return data;
    }

    clone(): CustomerClusterUpdateDto {
        const json = this.toJSON();
        let result = new CustomerClusterUpdateDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerClusterUpdateDto {
    clusterId: number;
    customerId: string | undefined;
    documentNumber: string | undefined;
}

export class ClienteUnicoUploadDto implements IClienteUnicoUploadDto {
    clusterId!: number;
    url!: string | undefined;
    countryCode!: string | undefined;

    constructor(data?: IClienteUnicoUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clusterId = _data["clusterId"];
            this.url = _data["url"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): ClienteUnicoUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClienteUnicoUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterId"] = this.clusterId;
        data["url"] = this.url;
        data["countryCode"] = this.countryCode;
        return data;
    }

    clone(): ClienteUnicoUploadDto {
        const json = this.toJSON();
        let result = new ClienteUnicoUploadDto();
        result.init(json);
        return result;
    }
}

export interface IClienteUnicoUploadDto {
    clusterId: number;
    url: string | undefined;
    countryCode: string | undefined;
}

export class InvoiceDto implements IInvoiceDto {
    id_Externo!: string | undefined;
    epoch!: string | undefined;
    fecha!: moment.Moment | undefined;
    factura!: string | undefined;
    importe!: number;
    origen!: string | undefined;
    payment_Method!: string | undefined;
    canal!: string | undefined;
    doc_Entry!: string | undefined;
    nombreCliente!: string | undefined;
    importeNeto!: number;
    importeBruto!: number;
    descuentos!: number;
    contribucion!: number;
    numserie!: string | undefined;
    numalbaran!: string | undefined;
    invoiceLink!: string | undefined;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id_Externo = _data["id_Externo"];
            this.epoch = _data["epoch"];
            this.fecha = _data["fecha"] ? moment(_data["fecha"].toString()) : <any>undefined;
            this.factura = _data["factura"];
            this.importe = _data["importe"];
            this.origen = _data["origen"];
            this.payment_Method = _data["payment_Method"];
            this.canal = _data["canal"];
            this.doc_Entry = _data["doc_Entry"];
            this.nombreCliente = _data["nombreCliente"];
            this.importeNeto = _data["importeNeto"];
            this.importeBruto = _data["importeBruto"];
            this.descuentos = _data["descuentos"];
            this.contribucion = _data["contribucion"];
            this.numserie = _data["numserie"];
            this.numalbaran = _data["numalbaran"];
            this.invoiceLink = _data["invoiceLink"];
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id_Externo"] = this.id_Externo;
        data["epoch"] = this.epoch;
        data["fecha"] = this.fecha ? this.fecha.toISOString() : <any>undefined;
        data["factura"] = this.factura;
        data["importe"] = this.importe;
        data["origen"] = this.origen;
        data["payment_Method"] = this.payment_Method;
        data["canal"] = this.canal;
        data["doc_Entry"] = this.doc_Entry;
        data["nombreCliente"] = this.nombreCliente;
        data["importeNeto"] = this.importeNeto;
        data["importeBruto"] = this.importeBruto;
        data["descuentos"] = this.descuentos;
        data["contribucion"] = this.contribucion;
        data["numserie"] = this.numserie;
        data["numalbaran"] = this.numalbaran;
        data["invoiceLink"] = this.invoiceLink;
        return data;
    }

    clone(): InvoiceDto {
        const json = this.toJSON();
        let result = new InvoiceDto();
        result.init(json);
        return result;
    }
}

export interface IInvoiceDto {
    id_Externo: string | undefined;
    epoch: string | undefined;
    fecha: moment.Moment | undefined;
    factura: string | undefined;
    importe: number;
    origen: string | undefined;
    payment_Method: string | undefined;
    canal: string | undefined;
    doc_Entry: string | undefined;
    nombreCliente: string | undefined;
    importeNeto: number;
    importeBruto: number;
    descuentos: number;
    contribucion: number;
    numserie: string | undefined;
    numalbaran: string | undefined;
    invoiceLink: string | undefined;
}

export class DetailDto implements IDetailDto {
    sku!: string | undefined;
    descripcion!: string | undefined;
    cantidad!: number;
    precio!: number;
    importe!: number;
    descuentos!: number;
    readonly importeNeto!: number;
    contribucion!: number;

    constructor(data?: IDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["sku"];
            this.descripcion = _data["descripcion"];
            this.cantidad = _data["cantidad"];
            this.precio = _data["precio"];
            this.importe = _data["importe"];
            this.descuentos = _data["descuentos"];
            (<any>this).importeNeto = _data["importeNeto"];
            this.contribucion = _data["contribucion"];
        }
    }

    static fromJS(data: any): DetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new DetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["descripcion"] = this.descripcion;
        data["cantidad"] = this.cantidad;
        data["precio"] = this.precio;
        data["importe"] = this.importe;
        data["descuentos"] = this.descuentos;
        data["importeNeto"] = this.importeNeto;
        data["contribucion"] = this.contribucion;
        return data;
    }

    clone(): DetailDto {
        const json = this.toJSON();
        let result = new DetailDto();
        result.init(json);
        return result;
    }
}

export interface IDetailDto {
    sku: string | undefined;
    descripcion: string | undefined;
    cantidad: number;
    precio: number;
    importe: number;
    descuentos: number;
    importeNeto: number;
    contribucion: number;
}

export class DocumentDto implements IDocumentDto {
    type!: string | undefined;
    documentUrl!: string | undefined;
    status!: string | undefined;
    draftNumber!: string | undefined;
    number!: string | undefined;
    folioNumber!: string | undefined;
    amount!: number;
    additionalInfo!: string | undefined;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.documentUrl = _data["documentUrl"];
            this.status = _data["status"];
            this.draftNumber = _data["draftNumber"];
            this.number = _data["number"];
            this.folioNumber = _data["folioNumber"];
            this.amount = _data["amount"];
            this.additionalInfo = _data["additionalInfo"];
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["documentUrl"] = this.documentUrl;
        data["status"] = this.status;
        data["draftNumber"] = this.draftNumber;
        data["number"] = this.number;
        data["folioNumber"] = this.folioNumber;
        data["amount"] = this.amount;
        data["additionalInfo"] = this.additionalInfo;
        return data;
    }

    clone(): DocumentDto {
        const json = this.toJSON();
        let result = new DocumentDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentDto {
    type: string | undefined;
    documentUrl: string | undefined;
    status: string | undefined;
    draftNumber: string | undefined;
    number: string | undefined;
    folioNumber: string | undefined;
    amount: number;
    additionalInfo: string | undefined;
}

export class ShippingTypeDto implements IShippingTypeDto {
    code!: string | undefined;
    name!: string | undefined;
    shippingTypeGroupId!: number | undefined;
    shippingTypeGroupName!: string | undefined;
    id!: number;

    constructor(data?: IShippingTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.shippingTypeGroupId = _data["shippingTypeGroupId"];
            this.shippingTypeGroupName = _data["shippingTypeGroupName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShippingTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["shippingTypeGroupId"] = this.shippingTypeGroupId;
        data["shippingTypeGroupName"] = this.shippingTypeGroupName;
        data["id"] = this.id;
        return data;
    }

    clone(): ShippingTypeDto {
        const json = this.toJSON();
        let result = new ShippingTypeDto();
        result.init(json);
        return result;
    }
}

export interface IShippingTypeDto {
    code: string | undefined;
    name: string | undefined;
    shippingTypeGroupId: number | undefined;
    shippingTypeGroupName: string | undefined;
    id: number;
}

export class DeliveryDataDto implements IDeliveryDataDto {
    estimatedDeliveryDateFrom!: moment.Moment | undefined;
    estimatedDeliveryDateTo!: moment.Moment | undefined;
    deliveryType!: string | undefined;
    pointOfDelivery!: string | undefined;
    addressTypeCode!: string | undefined;
    street!: string | undefined;
    number!: string | undefined;
    complement!: string | undefined;
    postalCode!: string | undefined;
    neighborhood!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    country!: string | undefined;
    geoLat!: number | undefined;
    geoLong!: number | undefined;
    readonly completeAddress!: string | undefined;
    trackingMethod!: string | undefined;
    trackingNumber!: string | undefined;
    shippingCost!: number;
    deliveryCompany!: string | undefined;
    shippingTypeId!: number | undefined;
    shippingType!: ShippingTypeDto;
    shippingTypeSourceCode!: string | undefined;
    receiverName!: string | undefined;
    carrierEsimatedDeliveryDate!: moment.Moment | undefined;
    id!: number;

    constructor(data?: IDeliveryDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estimatedDeliveryDateFrom = _data["estimatedDeliveryDateFrom"] ? moment(_data["estimatedDeliveryDateFrom"].toString()) : <any>undefined;
            this.estimatedDeliveryDateTo = _data["estimatedDeliveryDateTo"] ? moment(_data["estimatedDeliveryDateTo"].toString()) : <any>undefined;
            this.deliveryType = _data["deliveryType"];
            this.pointOfDelivery = _data["pointOfDelivery"];
            this.addressTypeCode = _data["addressTypeCode"];
            this.street = _data["street"];
            this.number = _data["number"];
            this.complement = _data["complement"];
            this.postalCode = _data["postalCode"];
            this.neighborhood = _data["neighborhood"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.geoLat = _data["geoLat"];
            this.geoLong = _data["geoLong"];
            (<any>this).completeAddress = _data["completeAddress"];
            this.trackingMethod = _data["trackingMethod"];
            this.trackingNumber = _data["trackingNumber"];
            this.shippingCost = _data["shippingCost"];
            this.deliveryCompany = _data["deliveryCompany"];
            this.shippingTypeId = _data["shippingTypeId"];
            this.shippingType = _data["shippingType"] ? ShippingTypeDto.fromJS(_data["shippingType"]) : <any>undefined;
            this.shippingTypeSourceCode = _data["shippingTypeSourceCode"];
            this.receiverName = _data["receiverName"];
            this.carrierEsimatedDeliveryDate = _data["carrierEsimatedDeliveryDate"] ? moment(_data["carrierEsimatedDeliveryDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeliveryDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estimatedDeliveryDateFrom"] = this.estimatedDeliveryDateFrom ? this.estimatedDeliveryDateFrom.toISOString() : <any>undefined;
        data["estimatedDeliveryDateTo"] = this.estimatedDeliveryDateTo ? this.estimatedDeliveryDateTo.toISOString() : <any>undefined;
        data["deliveryType"] = this.deliveryType;
        data["pointOfDelivery"] = this.pointOfDelivery;
        data["addressTypeCode"] = this.addressTypeCode;
        data["street"] = this.street;
        data["number"] = this.number;
        data["complement"] = this.complement;
        data["postalCode"] = this.postalCode;
        data["neighborhood"] = this.neighborhood;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["geoLat"] = this.geoLat;
        data["geoLong"] = this.geoLong;
        data["completeAddress"] = this.completeAddress;
        data["trackingMethod"] = this.trackingMethod;
        data["trackingNumber"] = this.trackingNumber;
        data["shippingCost"] = this.shippingCost;
        data["deliveryCompany"] = this.deliveryCompany;
        data["shippingTypeId"] = this.shippingTypeId;
        data["shippingType"] = this.shippingType ? this.shippingType.toJSON() : <any>undefined;
        data["shippingTypeSourceCode"] = this.shippingTypeSourceCode;
        data["receiverName"] = this.receiverName;
        data["carrierEsimatedDeliveryDate"] = this.carrierEsimatedDeliveryDate ? this.carrierEsimatedDeliveryDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): DeliveryDataDto {
        const json = this.toJSON();
        let result = new DeliveryDataDto();
        result.init(json);
        return result;
    }
}

export interface IDeliveryDataDto {
    estimatedDeliveryDateFrom: moment.Moment | undefined;
    estimatedDeliveryDateTo: moment.Moment | undefined;
    deliveryType: string | undefined;
    pointOfDelivery: string | undefined;
    addressTypeCode: string | undefined;
    street: string | undefined;
    number: string | undefined;
    complement: string | undefined;
    postalCode: string | undefined;
    neighborhood: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    geoLat: number | undefined;
    geoLong: number | undefined;
    completeAddress: string | undefined;
    trackingMethod: string | undefined;
    trackingNumber: string | undefined;
    shippingCost: number;
    deliveryCompany: string | undefined;
    shippingTypeId: number | undefined;
    shippingType: ShippingTypeDto;
    shippingTypeSourceCode: string | undefined;
    receiverName: string | undefined;
    carrierEsimatedDeliveryDate: moment.Moment | undefined;
    id: number;
}

export class OrderItemDto implements IOrderItemDto {
    sku!: string | undefined;
    description!: string | undefined;
    quantity!: number;
    netAmount!: number;
    grossAmount!: number;
    imageUrl!: string | undefined;
    barCode!: string | undefined;
    id!: number;

    constructor(data?: IOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.netAmount = _data["netAmount"];
            this.grossAmount = _data["grossAmount"];
            this.imageUrl = _data["imageUrl"];
            this.barCode = _data["barCode"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["netAmount"] = this.netAmount;
        data["grossAmount"] = this.grossAmount;
        data["imageUrl"] = this.imageUrl;
        data["barCode"] = this.barCode;
        data["id"] = this.id;
        return data;
    }

    clone(): OrderItemDto {
        const json = this.toJSON();
        let result = new OrderItemDto();
        result.init(json);
        return result;
    }
}

export interface IOrderItemDto {
    sku: string | undefined;
    description: string | undefined;
    quantity: number;
    netAmount: number;
    grossAmount: number;
    imageUrl: string | undefined;
    barCode: string | undefined;
    id: number;
}

export class OrderDto implements IOrderDto {
    sourceCode!: string | undefined;
    sourceCreationTime!: moment.Moment;
    sourceName!: string | undefined;
    customer!: ClienteUnicoItemGridDto;
    currentAssignedToStoreCode!: string | undefined;
    currentAssignedToStoreName!: string | undefined;
    currentCommercialStatus!: string | undefined;
    currentFinancialStatus!: string | undefined;
    currentLogisticStatus!: string | undefined;
    currentOverallStatus!: string | undefined;
    documents!: DocumentDto[] | undefined;
    balance!: number;
    grossAmount!: number;
    netAmount!: number;
    discount!: number;
    deliveryData!: DeliveryDataDto;
    dispatchDate!: moment.Moment | undefined;
    dispatchTag!: string | undefined;
    deliveredOn!: moment.Moment | undefined;
    orderItems!: OrderItemDto[] | undefined;
    fidelidadOrderPoints!: FidelidadOrderPointsDto;
    id!: number;

    constructor(data?: IOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.sourceCreationTime = _data["sourceCreationTime"] ? moment(_data["sourceCreationTime"].toString()) : <any>undefined;
            this.sourceName = _data["sourceName"];
            this.customer = _data["customer"] ? ClienteUnicoItemGridDto.fromJS(_data["customer"]) : <any>undefined;
            this.currentAssignedToStoreCode = _data["currentAssignedToStoreCode"];
            this.currentAssignedToStoreName = _data["currentAssignedToStoreName"];
            this.currentCommercialStatus = _data["currentCommercialStatus"];
            this.currentFinancialStatus = _data["currentFinancialStatus"];
            this.currentLogisticStatus = _data["currentLogisticStatus"];
            this.currentOverallStatus = _data["currentOverallStatus"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.balance = _data["balance"];
            this.grossAmount = _data["grossAmount"];
            this.netAmount = _data["netAmount"];
            this.discount = _data["discount"];
            this.deliveryData = _data["deliveryData"] ? DeliveryDataDto.fromJS(_data["deliveryData"]) : <any>undefined;
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : <any>undefined;
            this.dispatchTag = _data["dispatchTag"];
            this.deliveredOn = _data["deliveredOn"] ? moment(_data["deliveredOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems!.push(OrderItemDto.fromJS(item));
            }
            this.fidelidadOrderPoints = _data["fidelidadOrderPoints"] ? FidelidadOrderPointsDto.fromJS(_data["fidelidadOrderPoints"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["sourceCreationTime"] = this.sourceCreationTime ? this.sourceCreationTime.toISOString() : <any>undefined;
        data["sourceName"] = this.sourceName;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["currentAssignedToStoreCode"] = this.currentAssignedToStoreCode;
        data["currentAssignedToStoreName"] = this.currentAssignedToStoreName;
        data["currentCommercialStatus"] = this.currentCommercialStatus;
        data["currentFinancialStatus"] = this.currentFinancialStatus;
        data["currentLogisticStatus"] = this.currentLogisticStatus;
        data["currentOverallStatus"] = this.currentOverallStatus;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["balance"] = this.balance;
        data["grossAmount"] = this.grossAmount;
        data["netAmount"] = this.netAmount;
        data["discount"] = this.discount;
        data["deliveryData"] = this.deliveryData ? this.deliveryData.toJSON() : <any>undefined;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : <any>undefined;
        data["dispatchTag"] = this.dispatchTag;
        data["deliveredOn"] = this.deliveredOn ? this.deliveredOn.toISOString() : <any>undefined;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        data["fidelidadOrderPoints"] = this.fidelidadOrderPoints ? this.fidelidadOrderPoints.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): OrderDto {
        const json = this.toJSON();
        let result = new OrderDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDto {
    sourceCode: string | undefined;
    sourceCreationTime: moment.Moment;
    sourceName: string | undefined;
    customer: ClienteUnicoItemGridDto;
    currentAssignedToStoreCode: string | undefined;
    currentAssignedToStoreName: string | undefined;
    currentCommercialStatus: string | undefined;
    currentFinancialStatus: string | undefined;
    currentLogisticStatus: string | undefined;
    currentOverallStatus: string | undefined;
    documents: DocumentDto[] | undefined;
    balance: number;
    grossAmount: number;
    netAmount: number;
    discount: number;
    deliveryData: DeliveryDataDto;
    dispatchDate: moment.Moment | undefined;
    dispatchTag: string | undefined;
    deliveredOn: moment.Moment | undefined;
    orderItems: OrderItemDto[] | undefined;
    fidelidadOrderPoints: FidelidadOrderPointsDto;
    id: number;
}

export class OrderDtoListResultDto implements IOrderDtoListResultDto {
    items!: OrderDto[] | undefined;

    // Paginacion de facturas que agrega Orders/GetOrders. Ver OrderPagedListResultDto
    // en el backend. Son campos aditivos: si el backend no los manda quedan undefined.
    pageIndex!: number | undefined;
    pageSize!: number | undefined;
    dias!: number | undefined;
    totalInvoices!: number | undefined;
    totalPages!: number | undefined;

    constructor(data?: IOrderDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderDto.fromJS(item));
            }
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            this.dias = _data["dias"];
            this.totalInvoices = _data["totalInvoices"];
            this.totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): OrderDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        data["dias"] = this.dias;
        data["totalInvoices"] = this.totalInvoices;
        data["totalPages"] = this.totalPages;
        return data;
    }

    clone(): OrderDtoListResultDto {
        const json = this.toJSON();
        let result = new OrderDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDtoListResultDto {
    items: OrderDto[] | undefined;
}

export class CurrentStatusDto implements ICurrentStatusDto {
    processId!: number;
    status!: string | undefined;
    currentStep!: string[] | undefined;

    constructor(data?: ICurrentStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processId = _data["processId"];
            this.status = _data["status"];
            if (Array.isArray(_data["currentStep"])) {
                this.currentStep = [] as any;
                for (let item of _data["currentStep"])
                    this.currentStep!.push(item);
            }
        }
    }

    static fromJS(data: any): CurrentStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processId"] = this.processId;
        data["status"] = this.status;
        if (Array.isArray(this.currentStep)) {
            data["currentStep"] = [];
            for (let item of this.currentStep)
                data["currentStep"].push(item);
        }
        return data;
    }

    clone(): CurrentStatusDto {
        const json = this.toJSON();
        let result = new CurrentStatusDto();
        result.init(json);
        return result;
    }
}

export interface ICurrentStatusDto {
    processId: number;
    status: string | undefined;
    currentStep: string[] | undefined;
}

export class ProcessDto implements IProcessDto {
    name!: string | undefined;
    status!: string | undefined;
    creationTime!: moment.Moment;
    currentStatus!: CurrentStatusDto;
    output!: string | undefined;
    readonly action!: string | undefined;
    parameters!: string | undefined;

    constructor(data?: IProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.status = _data["status"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.currentStatus = _data["currentStatus"] ? CurrentStatusDto.fromJS(_data["currentStatus"]) : <any>undefined;
            this.output = _data["output"];
            (<any>this).action = _data["action"];
            this.parameters = _data["parameters"];
        }
    }

    static fromJS(data: any): ProcessDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["status"] = this.status;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["currentStatus"] = this.currentStatus ? this.currentStatus.toJSON() : <any>undefined;
        data["output"] = this.output;
        data["action"] = this.action;
        data["parameters"] = this.parameters;
        return data;
    }

    clone(): ProcessDto {
        const json = this.toJSON();
        let result = new ProcessDto();
        result.init(json);
        return result;
    }
}

export interface IProcessDto {
    name: string | undefined;
    status: string | undefined;
    creationTime: moment.Moment;
    currentStatus: CurrentStatusDto;
    output: string | undefined;
    action: string | undefined;
    parameters: string | undefined;
}

export class StateDto implements IStateDto {
    name!: string | undefined;
    cities!: CityDto[] | undefined;
    countryCode!: string | undefined;
    id!: number;

    constructor(data?: IStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["cities"])) {
                this.cities = [] as any;
                for (let item of _data["cities"])
                    this.cities!.push(CityDto.fromJS(item));
            }
            this.countryCode = _data["countryCode"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StateDto {
        data = typeof data === 'object' ? data : {};
        let result = new StateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.cities)) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item.toJSON());
        }
        data["countryCode"] = this.countryCode;
        data["id"] = this.id;
        return data;
    }

    clone(): StateDto {
        const json = this.toJSON();
        let result = new StateDto();
        result.init(json);
        return result;
    }
}

export interface IStateDto {
    name: string | undefined;
    cities: CityDto[] | undefined;
    countryCode: string | undefined;
    id: number;
}

export class StateDtoPagedResultDto implements IStateDtoPagedResultDto {
    totalCount!: number;
    items!: StateDto[] | undefined;

    constructor(data?: IStateDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StateDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StateDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): StateDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StateDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStateDtoPagedResultDto {
    totalCount: number;
    items: StateDto[] | undefined;
}

export class PetDtoListResultDto implements IPetDtoListResultDto {
    items!: PetDto[] | undefined;

    constructor(data?: IPetDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PetDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PetDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PetDtoListResultDto {
        const json = this.toJSON();
        let result = new PetDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPetDtoListResultDto {
    items: PetDto[] | undefined;
}

export class CreateUpdatePetDto implements ICreateUpdatePetDto {
    id!: number;
    name!: string | undefined;
    birthdate!: moment.Moment | undefined;
    speciesId!: number;
    breedId!: number;
    microChip!: string | undefined;
    color!: string | undefined;
    pictureUrl!: string | undefined;
    gender!: number;
    sourceType!: number;
    customerIdUnico!: string | undefined;
    clienteUnico!: ClienteUnicoDto;

    constructor(data?: ICreateUpdatePetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.birthdate = _data["birthdate"] ? moment(_data["birthdate"].toString()) : <any>undefined;
            this.speciesId = _data["speciesId"];
            this.breedId = _data["breedId"];
            this.microChip = _data["microChip"];
            this.color = _data["color"];
            this.pictureUrl = _data["pictureUrl"];
            this.gender = _data["gender"];
            this.sourceType = _data["sourceType"];
            this.customerIdUnico = _data["customerIdUnico"];
            this.clienteUnico = _data["clienteUnico"] ? ClienteUnicoDto.fromJS(_data["clienteUnico"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateUpdatePetDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdatePetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : <any>undefined;
        data["speciesId"] = this.speciesId;
        data["breedId"] = this.breedId;
        data["microChip"] = this.microChip;
        data["color"] = this.color;
        data["pictureUrl"] = this.pictureUrl;
        data["gender"] = this.gender;
        data["sourceType"] = this.sourceType;
        data["customerIdUnico"] = this.customerIdUnico;
        data["clienteUnico"] = this.clienteUnico ? this.clienteUnico.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateUpdatePetDto {
        const json = this.toJSON();
        let result = new CreateUpdatePetDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUpdatePetDto {
    id: number;
    name: string | undefined;
    birthdate: moment.Moment | undefined;
    speciesId: number;
    breedId: number;
    microChip: string | undefined;
    color: string | undefined;
    pictureUrl: string | undefined;
    gender: number;
    sourceType: number;
    customerIdUnico: string | undefined;
    clienteUnico: ClienteUnicoDto;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}